import {FormatInterface} from './FormatInterface';
import {FormatterInterface} from './FormatterInterface';
import {Format} from './Format';
export abstract class BaseFormatter<T = string> implements FormatterInterface<T> {
	protected format:FormatInterface;

	constructor(format:FormatInterface) {
		this.format = Format.copy(format);
	}

	public getFormat():FormatInterface {
		return this.format;
	}

	public abstract render(value: T):string;
	public abstract read(value: string):T;
}
